var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgEqualizer = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.919 16.1993C8.06362 15.7894 8.33182 15.4345 8.68662 15.1834C9.04142 14.9324 9.46536 14.7975 9.9 14.7975C10.3346 14.7975 10.7586 14.9324 11.1134 15.1834C11.4682 15.4345 11.7364 15.7894 11.881 16.1993H19V17.5993H11.881C11.7364 18.0091 11.4682 18.3641 11.1134 18.6151C10.7586 18.8662 10.3346 19.001 9.9 19.001C9.46536 19.001 9.04142 18.8662 8.68662 18.6151C8.33182 18.3641 8.06362 18.0091 7.919 17.5993H5V16.1993H7.919ZM12.119 11.2993C12.2636 10.8894 12.5318 10.5345 12.8866 10.2834C13.2414 10.0324 13.6654 9.89754 14.1 9.89754C14.5346 9.89754 14.9586 10.0324 15.3134 10.2834C15.6682 10.5345 15.9364 10.8894 16.081 11.2993H19V12.6993H16.081C15.9364 13.1091 15.6682 13.4641 15.3134 13.7151C14.9586 13.9662 14.5346 14.101 14.1 14.101C13.6654 14.101 13.2414 13.9662 12.8866 13.7151C12.5318 13.4641 12.2636 13.1091 12.119 12.6993H5V11.2993H12.119ZM7.919 6.39926C8.06362 5.98939 8.33182 5.63446 8.68662 5.38341C9.04142 5.13236 9.46536 4.99754 9.9 4.99754C10.3346 4.99754 10.7586 5.13236 11.1134 5.38341C11.4682 5.63446 11.7364 5.98939 11.881 6.39926H19V7.79926H11.881C11.7364 8.20913 11.4682 8.56405 11.1134 8.81511C10.7586 9.06616 10.3346 9.20097 9.9 9.20097C9.46536 9.20097 9.04142 9.06616 8.68662 8.81511C8.33182 8.56405 8.06362 8.20913 7.919 7.79926H5V6.39926H7.919Z"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgEqualizer);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/equalizer.fa2faec6f228039c49208dda016ba0e2.svg";